import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { forwardRef, useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router';
import track from 'src/utils/analytics';

const Page = forwardRef(({ title, children, className, ...rest }, ref) => {
  const location = useLocation();

  const sendPageViewEvent = useCallback(() => {
    track.pageview({
      page_path: location.pathname
    });
  }, [location]);

  useEffect(() => {
    sendPageViewEvent();
  }, [sendPageViewEvent]);

  return (
    <div ref={ref} className={clsx(className)} {...rest}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </div>
  );
});

Page.displayName = 'Page';
Page.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string
};

export default Page;
